;
(function ($) {
  var dataKey = 'app.accordion';
  var Accordion = function Accordion(element, options) {
    this.element = element;
    this.init(options);
  };
  Accordion.prototype = {
    attr: {
      accordion: 'data-accordion',
      accordionGroup: 'data-accordion-group'
    },
    value: {
      trigger: 'trigger',
      content: 'content',
      speed: 'fast'
    },
    classes: {
      active: 'active',
      icon: 'icon',
      openIcon: 'fa-plus',
      closeIcon: 'fa-minus'
    },
    /**
     * Initialise Accordion
     * Listens for a mouse click on the accordion triggers.
     * Listens for a key press (spacebar) on the accordion triggers. This is for accessibility purposes.
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      var _this = this;
      $(this.element).find(this._getAccordionTrigger()).each(function () {
        $(this).on('click', function () {
          _this._expandAccordionContent($(this));
        });
        $(this).bind('keypress', function (e) {
          if (e.keyCode == 32) {
            _this._expandAccordionContent($(this));
            return false;
          }
        });
      });
    },
    /**
     * Expand Accodion Content
     * Expands the selected accordion item content.
     * Checks if the content is already open, collapses then updates the current icon.
     * If the content is not open, collapse all others and open the selected item content and update the icon.
     * @private
     * @param {string} trigger - The active accordion item trigger.
     */

    _expandAccordionContent: function _expandAccordionContent(trigger) {
      var content = trigger.parent().find(this._getAccordionContent());
      if (content.parent().hasClass(this.classes.active)) {
        this._collapseCurrent(content.parent());
        this._changeIconToOpen(trigger);
      } else {
        this._collapseAll();
        content.parent().addClass(this.classes.active);
        content.show(this.value.speed);
        this._changeIconToClose(trigger);
      }
    },
    /**
     * Get Accordion Trigger
     * Returns the accordion trigger element.
     * @private
     */

    _getAccordionTrigger: function _getAccordionTrigger() {
      var selector = '[' + this.attr.accordion + '="' + this.value.trigger + '"]';
      if ($(this.element).is('[' + this.attr.accordionGroup + ']')) selector += this._accordionGroupSelector($(this.element).attr(this.attr.accordionGroup));
      return selector;
    },
    /**
     * Get Accordion Content
     * Returns the accordion content in relation to the active trigger.
     * @private
     */

    _getAccordionContent: function _getAccordionContent() {
      var selector = '[' + this.attr.accordion + '="' + this.value.content + '"]';
      if ($(this.element).is('[' + this.attr.accordionGroup + ']')) selector += this._accordionGroupSelector($(this.element).attr(this.attr.accordionGroup));
      return selector;
    },
    /**
     * Get Accordion Active
     * Returns the accordion expanded items in relation to the active trigger.
     * @private
     */

    _getAccordionActive: function _getAccordionActive() {
      var selector = '.' + this.classes.active;
      if ($(this.element).is('[' + this.attr.accordionGroup + ']')) selector += this._accordionGroupSelector($(this.element).attr(this.attr.accordionGroup));
      return selector;
    },
    /**
     * Collapse All
     * Collapses all open accordion items before openeing the active element.
     * @private
     */

    _collapseAll: function _collapseAll() {
      var _this = this;
      var expanded = $(this.element).find(_this._getAccordionActive());
      if (expanded.length > 0) {
        expanded.each(function () {
          var content = $(this).find(_this._getAccordionContent());
          var trigger = $(this).find(_this._getAccordionTrigger());
          content.hide(_this.value.speed);
          _this._changeIconToOpen(trigger);
          $(this).removeClass(_this.classes.active);
        });
      }
    },
    /**
     * Collapse Current
     * Collapses the current accordion item if it is selected whilst currently open.
     * @private
     */

    _collapseCurrent: function _collapseCurrent(elm) {
      $(elm).removeClass(this.classes.active);
      $(elm).find(this._getAccordionContent()).hide(this.value.speed);
    },
    /**
     * Change Icon to Open
     * Updates the current icon to open when the trigger is selected.
     * @private
     */

    _changeIconToOpen: function _changeIconToOpen(trigger) {
      var icon = trigger.find('.' + this.classes.icon);
      icon.addClass(this.classes.openIcon);
      icon.removeClass(this.classes.closeIcon);
    },
    /**
     * Change Icon to Closed
     * Updates the current icon to closed when the current or other accordion item is selected.
     * @private
     */

    _changeIconToClose: function _changeIconToClose(trigger) {
      var icon = trigger.find('.' + this.classes.icon);
      icon.addClass(this.classes.closeIcon);
      icon.removeClass(this.classes.openIcon);
    },
    /**
     * Get Accordion Group Selector
     * If nesting of plugin occurs in HTML, use accordion group to diffirentiate between accordions
     * @param {string} group
     * @private
     */

    _accordionGroupSelector: function _accordionGroupSelector(group) {
      return '[' + this.attr.accordionGroup + '="' + group + '"]';
    }
  };

  /**
   * Global callback function which by default all [data-accordion] triggers this plugin.
   * @method $.fn.app_accordion()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_accordion();
   */

  $.fn.app_accordion = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof Accordion) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new Accordion(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);